import type { Quad, Term } from "@rdfjs/types"
import type { RDFTerm, SPARQLSelectResults } from "./types"

/** Convert an RDF/JS Term into the wire-shape RDFTerm used by sparql-results. */
export function termToRDFTerm(term: Term): RDFTerm {
  if (term.termType === "NamedNode") {
    return { type: "uri", value: term.value }
  }
  if (term.termType === "Literal") {
    const result: RDFTerm = { type: "literal", value: term.value }
    if ("language" in term && term.language) {
      result["xml:lang"] = term.language
    }
    if ("datatype" in term && term.datatype) {
      result.datatype = term.datatype.value
    }
    return result
  }
  if (term.termType === "BlankNode") {
    return { type: "bnode", value: term.value }
  }
  return { type: "literal", value: String(term.value) }
}

/**
 * Convert CONSTRUCT-shaped quads into a SELECT-shaped result with columns
 * `subject`, `predicate`, `object` so they can be rendered by <results-table>.
 */
export function quadsToSelectResults(quads: Quad[]): SPARQLSelectResults {
  return {
    type: "select",
    head: { vars: ["subject", "predicate", "object"] },
    results: {
      bindings: quads.map((quad) => ({
        subject: termToRDFTerm(quad.subject),
        predicate: termToRDFTerm(quad.predicate),
        object: termToRDFTerm(quad.object),
      })),
    },
  }
}
